import lodash from 'lodash';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import {
    Table, TableBody, TableCell, TableHead, TableRow, Tooltip, withStyles, TablePagination, TableSortLabel,
} from '@material-ui/core';
import { Icon, Tag, Spin } from 'antd';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';

import { table_styles } from '../../../../components/TableStyles';
import ActionsLead from './ActionsLead';
import {
    getLeadsRequest,
    setLeadManageKey,
    setLeadManagePagination,
    updateLeadManageKey,
} from '../redux/actions/get_leads.actions';
import { getUsersList } from '../redux/actions/get_users_list.actions';
import { get, getVal } from '../../../../shared/helpers';
import TableLoader from '../../../../components/table/TableLoader';
import TableNoData from '../../../../components/table/TableNoData';
import { TABLE_TITLES, TABLE_TITLES_DELIVERY_REQUESTED } from '../contants/table_titles.constants';
import { BLEMISH_COLOR } from '../../constants/blemish_color.constats';
import { getDivisionAbbr } from '../../utils/getDivisionAbbr';

import './styles/actionsLead.scss';

class LeadsTable extends Component {
    constructor(props) {
        super(props);
        this.updateCheckbox = this.updateCheckbox.bind(this);
        this.updateCheckBoxState = this.updateCheckBoxState.bind(this);
        this.checkPermissionForAllocate = this.checkPermissionForAllocate.bind(this);
        this.getCountyName = this.getCountyName.bind(this);

        this.state = {
            leadList: [],
            isUpdating: false,
        };
    }

    componentDidMount() {
        this.updateData();
    }

    updateData = () => {
        this.props.getLeadsRequest();
        this.setState({ leadList: [] });
    };

    checkPermissionForAllocate = () => {
        const allowedGroupsForAllocate = [
            // admin group id
            '5b6a9ee2ba52006858939023',
            // super user group id
            '5b6a9ee2ba52006858939024',
            // trade
            '5f477ffa143ca00bd466c4ec',
        ];
        const { current_user } = this.props;

        return getVal(current_user, 'groups').some((group) => allowedGroupsForAllocate.includes(group._id));
    };

    handleSortByDate = () => {
        const { filters, setLeadManageKey: setReduxKey } = this.props;

        const nextDirection = filters.sortDirection === -1 || !filters.sortDirection ? 1 : -1;
        setReduxKey('filters', { sortField: 'created_date', sortDirection: nextDirection });
        this.props.getLeadsRequest();
    }

    changePage = (event, page) => {
        if (event) {
            const { setLeadManagePagination: setLeadManagePaginationCall } = this.props;

            setLeadManagePaginationCall('pagination', {
                'pagination.page': page,
            });

            this.setState({ leadList: [] });
            this.updateData();
        }
    };

    handleChangeRowsPerPage = (event) => {
        if (event) {
            const rpp = event.target.value;
            const { setLeadManagePagination: setLeadManagePaginationCall } = this.props;

            setLeadManagePaginationCall('pagination', {
                'pagination.rows_per_page': rpp,
                'pagination.page': 0,
            });

            this.setState({ leadList: [] });
            this.updateData();
        }
    };

    updateCheckbox(e) {
        const leadId = e.target.getAttribute('data-id');
        const division = e.target.getAttribute('data-division');

        let { leadList } = this.state;

        if (leadList.length === 0) {
            leadList = [];
            leadList.push({ id: leadId, division });
            this.setState({ leadList });
        } else {
            const exists = leadList.filter((item) => item.id === leadId);

            if (exists.length > 0) {
                leadList = leadList.filter((item) => item.id !== leadId);
                this.setState({ leadList });
            } else {
                leadList.push({ id: leadId, division });
                this.setState({ leadList });
            }
        }
    }

    updateCheckBoxState() {
        this.setState({ leadList: [] });
    }

    handleSelectAll = () => {
        const { leads } = this.props;
        const { leadList } = this.state;
        const selectedIds = new Set(leadList.map((item) => item.id));
        const allSelected = leads?.length > 0 && leads.every((lead) => selectedIds.has(lead._id));
        if (allSelected) {
            const currentPageIds = new Set(leads.map((lead) => lead._id));
            this.setState({ leadList: leadList.filter((item) => !currentPageIds.has(item.id)) });
        } else {
            const newLeads = leads
                .filter((lead) => !selectedIds.has(lead._id))
                .map((lead) => ({
                    id: lead._id,
                    division: lodash.get(lead, 'ref_lead_source.abbr') || 'Unknown',
                }));
            this.setState({ leadList: [...leadList, ...newLeads] });
        }
    };

    getCountyName = (countyId) => this.props.countyList.find(({ _id }) => _id === countyId)?.name;

    setIsUpdating = (value) => {
        this.setState({ isUpdating: value });
    }

    render() {
        const {
            classes: { root1, tableWrapper, table },
            leads,
            pagination,
            lead_profile_access,
            loading: isLoading,
            filters,
        } = this.props;
        const { leadList } = this.state;
        const selectedIds = new Set(leadList.map((item) => item.id));
        const allSelected = leads?.length > 0 && leads.every((lead) => selectedIds.has(lead._id));
        const { isLeadManageLeadomatic, isLeadManageDeliveryRequested } = this.props;
        let titles = isLeadManageDeliveryRequested ? TABLE_TITLES_DELIVERY_REQUESTED : TABLE_TITLES;

        if (!this.checkPermissionForAllocate()) {
            titles = titles.filter((e) => e.content !== 'Margin');
        }


        const leadsLength = leads?.length;
        const displayDataList = leadsLength < pagination.rows_per_page ? leadsLength : pagination.rows_per_page * (pagination.page + 2);

        return (
            <div className={root1} style={{ marginTop: 0, borderRadius: 0 }}>
                <div className={tableWrapper}>
                    <Table className={`${table} sbf-table`}>
                        <TableHead>
                            <TableRow style={{ height: '48px' }}>
                                {
                                    titles.map((col) => {
                                        if (col.content === 'Assign' && this.checkPermissionForAllocate() && !isLeadManageDeliveryRequested) {
                                            return (
                                                <TableCell key={col.content} align={col.align} style={{ width: col.width }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={allSelected}
                                                        onChange={this.handleSelectAll}
                                                        title="Select all"
                                                        aria-label="Select all"
                                                    />
                                                </TableCell>
                                            );
                                        }
                                        const sortDir = filters.sortDirection === 1 ? 'asc' : 'desc';
                                        return (
                                            <TableCell
                                                key={col.content}
                                                align={col.align}
                                                style={{ width: [col.width] }}
                                            >
                                                {col.content === 'Date' && !isLeadManageDeliveryRequested
                                                    ? (
                                                        <TableSortLabel
                                                            active
                                                            direction={sortDir}
                                                            onClick={this.handleSortByDate}
                                                        >
                                                            {col.content}
                                                        </TableSortLabel>
                                                    )
                                                    : <>{col.content}</>
                                                }
                                            </TableCell>
                                        );
                                    })
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                isLoading
                                    ? <TableLoader colSpan={titles.length} />
                                    : leads && leads.map((lead, index) => {
                                        let rowClassName = '';
                                        if (lead.served_live_price && !lead.use_live_price) rowClassName = 'boldRowYellow';
                                        else if (lead.served_live_price && lead.use_live_price) rowClassName = 'boldRowRed';

                                        let vrm = '-';
                                        if (lead.ref_bike_lead && lead.ref_bike_lead.vrm) {
                                            vrm = lead.ref_bike_lead.vrm.toUpperCase();
                                        }

                                        const bl = lead.ref_bike_lead;
                                        let bikeDisplay;
                                        if (bl && bl.ref_bike_brand && bl.ref_bike_model) {
                                            bikeDisplay = <span>{`${bl.ref_bike_brand.name} ${bl.ref_bike_model.name} ${bl.ref_bike_model.model_variation || ''}`}</span>;
                                        } else if (bl && bl.ref_bike_brand && bl.unmaped_data && Object.keys(bl.unmaped_data).length !== 1) {
                                            bikeDisplay = <span>{`${bl.ref_bike_brand.name} ${bl.unmaped_data.bike_model}`}</span>;
                                        } else if (bl && bl.ref_bike_brand) {
                                            bikeDisplay = <span>{bl.ref_bike_brand.name}</span>;
                                        } else {
                                            bikeDisplay = (
                                                <span style={{ fontStyle: 'italic', color: 'lightgray' }}>
                                                    Unknown
                                                </span>
                                            );
                                        }

                                        let blemishStep = '';
                                        if (lead.completed_blemish_step === 'step-1') blemishStep = '25%';
                                        else if (lead.completed_blemish_step === 'step-2') blemishStep = '50%';
                                        else if (lead.completed_blemish_step === 'step-3') blemishStep = '75%';
                                        else if (lead.completed_blemish_step === 'step-4') blemishStep = '100%';

                                        let bikeYear = '-';
                                        if (bl && bl.ref_bike_variant) {
                                            bikeYear = bl.ref_bike_variant.year;
                                        } else if (bl && bl.unmaped_data && bl.unmaped_data.bike_year) {
                                            bikeYear = bl.unmaped_data.bike_year;
                                        }

                                        let bikeCC = '-';
                                        if (bl && bl.ref_bike_model) {
                                            bikeCC = bl.ref_bike_model.cc;
                                        } else if (bl && bl.unmaped_data && bl.unmaped_data.bike_cc) {
                                            bikeCC = bl.unmaped_data.bike_cc;
                                        }

                                        return (
                                            <TableRow
                                                key={lead._id}
                                                className={rowClassName}
                                            >
                                                <TableCell align={titles[0].align}>
                                                    <span>{pagination.rows_per_page * pagination.page + index + 1}</span>
                                                </TableCell>
                                                <TableCell align={titles[1].align}>
                                                    <span>
                                                        <Tooltip title={<Moment format="D-MM-YYYY HH:mm">{isLeadManageDeliveryRequested ? lead.transport_requested_date : lead.created_date}</Moment>} placement="top">
                                                            <Moment format="D MMM HH:mm YYYY">{isLeadManageDeliveryRequested ? lead.transport_requested_date : lead.created_date}</Moment>
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                                <TableCell align={titles[2].align}>
                                                    <Link
                                                        to={!lead_profile_access ? { pathname: `/Leads/Lead_profile/${lead._id}`, search: `?isLeadomatic=${isLeadManageLeadomatic}&isDeliveryRequested=${isLeadManageDeliveryRequested}` } : { pathname: '' }}
                                                        style={{ color: 'black' }}
                                                    >
                                                        <span style={{ whiteSpace: 'nowrap' }}>
                                                            {vrm}
                                                        </span>
                                                    </Link>
                                                </TableCell>
                                                <TableCell align={titles[3].align}>
                                                    <Link
                                                        to={!lead_profile_access ? {
                                                            pathname: `/Leads/Lead_profile/${lead._id}`,
                                                            search: `?isLeadomatic=${isLeadManageLeadomatic}&isDeliveryRequested=${isLeadManageDeliveryRequested}`,
                                                        } : { pathname: '' }}
                                                        style={{ color: 'black' }}
                                                    >
                                                        {bikeDisplay}
                                                        {
                                                            getVal(lead, 'ref_bike_lead.ref_bike_model.name')
                                                    && (
                                                        <Icon
                                                            type="tag"
                                                            theme="twoTone"
                                                            twoToneColor="#28a745"
                                                            style={{ margin: 7 }}
                                                        />
                                                    )
                                                        }
                                                        {
                                                            lead.is_duplicate
                                                    && <small><Tag color="#f50" className="tag">Dupe</Tag></small>
                                                        }
                                                        {
                                                            lead.is_part_complete
                                                    && (
                                                        <small>
                                                            <Tag color="volcano" className="tag">
                                                                Part
                                                                complete
                                                            </Tag>
                                                        </small>
                                                    )
                                                        }
                                                        {
                                                            lead.deleted_date
                                                    && (
                                                        <small>
                                                            <Tag
                                                                color="#cc0000"
                                                                className="tag"
                                                            >
                                                                Deleted
                                                            </Tag>
                                                        </small>
                                                    )
                                                        }

                                                        {(lead.served_live_price && !lead.use_live_price)
                                                    && (
                                                        <small>
                                                            <Tag
                                                                color="#000000"
                                                                className="tag"
                                                            >
                                                                Auto Priced
                                                            </Tag>
                                                        </small>
                                                    )
                                                        }
                                                        {(lead.served_live_price && lead.use_live_price)
                                                    && (
                                                        <small>
                                                            <Tag
                                                                color="#000000"
                                                                className="tag"
                                                            >
                                                                Accepted Auto Priced
                                                            </Tag>
                                                        </small>
                                                    )
                                                        }
                                                        {
                                                            lead.part_ex && lead.part_ex.is_part_ex
                                                    && (
                                                        <small>
                                                            <Tag color="volcano" className="tag">
                                                                Part
                                                                Ex
                                                            </Tag>
                                                        </small>
                                                    )
                                                        }

                                                        {lead.is_manager_special
                                                    && (
                                                        <small>
                                                            <Tag color="#00cc00" className="tag">
                                                                Manager
                                                                Special
                                                            </Tag>
                                                        </small>
                                                    )}

                                                        {lead.has_completed_blemish && lead.lead_blemish_report.rag_rating && (
                                                            <small>
                                                                <Tag
                                                                    color={BLEMISH_COLOR[lead.lead_blemish_report.rag_rating]}
                                                                    className="tag"
                                                                >
                                                                    Blemish
                                                                    {' '}
                                                                    {blemishStep}
                                                                </Tag>
                                                            </small>
                                                        )}
                                                        {(lead.photos && lead.photos.length > 0)
                                                    && (
                                                        <small style={{ marginLeft: 5 }}>
                                                            {lead.photos.length}
                                                            {' '}
                                                            photos
                                                        </small>
                                                    )}

                                                    </Link>
                                                </TableCell>
                                                <TableCell align={titles[4].align}>
                                                    <span>
                                                        {bikeYear}
                                                    </span>
                                                </TableCell>
                                                <TableCell align={titles[5].align}>
                                                    <span>
                                                        {
                                                            lead.ref_bike_lead
                                                                ? lead.ref_bike_lead.mileage
                                                                : ''
                                                        }
                                                    </span>
                                                </TableCell>
                                                <TableCell align={titles[6].align}>
                                                    <span>
                                                        {bikeCC}
                                                    </span>
                                                </TableCell>
                                                <TableCell align={titles[7].align}>
                                                    {
                                                        (lead.valuations && lead.valuations.length)
                                                            ? (
                                                                <span>
                                                                    &pound;
                                                                    {lead.valuations[lead.valuations.length - 1].valuation}
                                                                </span>
                                                            )
                                                            : <span>-</span>
                                                    }
                                                </TableCell>
                                                {
                                                    this.checkPermissionForAllocate() && (
                                                        <TableCell align={titles[8].align}>
                                                            {
                                                                (lead.valuations && lead.valuations.length)
                                                                    ? (
                                                                        <span>
                                                                            {lead.valuations[lead.valuations.length - 1].suggested_margin ? (
                                                                                <>
                                                                                    &pound;
                                                                                    {lead.valuations[lead.valuations.length - 1].suggested_margin}
                                                                                </>
                                                                            )
                                                                                : <span>-</span>}
                                                                        </span>
                                                                    )
                                                                    : <span>-</span>
                                                            }
                                                        </TableCell>
                                                    )
                                                }
                                                <TableCell align={titles[9].align}>
                                                    <span>
                                                        {
                                                            lead.ref_lead_status
                                                                ? lead.ref_lead_status.name
                                                                : '-'
                                                        }
                                                    </span>
                                                </TableCell>
                                                <TableCell align={titles[10].align}>
                                                    <span>{get(lead, 'ref_lead_customer.phone') || '-'}</span>
                                                </TableCell>
                                                <TableCell align={titles[11].align}>
                                                    <span>{get(lead, 'ref_lead_customer.full_name') || '-'}</span>
                                                </TableCell>
                                                {isLeadManageDeliveryRequested && (
                                                    <>
                                                        <TableCell align={titles[12].align}>
                                                            <span>{get(lead, 'ref_lead_customer.address.post_code') || '-'}</span>
                                                        </TableCell>
                                                        <TableCell align={titles[13].align}>
                                                            <span>{this.getCountyName(get(lead, 'ref_lead_customer.address.county')) || '-'}</span>
                                                        </TableCell>
                                                    </>
                                                )}
                                                <TableCell align={titles.find(({ content }) => content === 'Division').align}>
                                                    <span>
                                                        {getDivisionAbbr(lodash.get(lead, 'ref_lead_source.abbr'))}
                                                    </span>
                                                </TableCell>
                                                <TableCell align={titles.find(({ content }) => content === 'Assigned').align}>
                                                    <span>
                                                        {
                                                            lead.ref_assigned_to
                                                                ? (
                                                                    <Tooltip
                                                                        title={`${lead.ref_assigned_to.person && lead.ref_assigned_to.person.first_name} ${lead.ref_assigned_to.person && lead.ref_assigned_to.person.last_name}`}
                                                                        placement="top"
                                                                    >
                                                                        {lead.ref_assigned_to.person
                                                                    && lead.ref_assigned_to.person.photos
                                                                    && lead.ref_assigned_to.person.photos.small
                                                                            ? (
                                                                                <img
                                                                                    src={lead.ref_assigned_to.person.photos.small}
                                                                                    alt="avatar"
                                                                                    style={{
                                                                                        borderRadius: '50%',
                                                                                        width: 35,
                                                                                        height: 35,
                                                                                    }}
                                                                                />
                                                                            )
                                                                            : (
                                                                                <div style={{ textAlign: 'center' }}>
                                                                                    {`${lead.ref_assigned_to.person?.first_name?.[0] ?? ''}${lead.ref_assigned_to.person?.last_name?.[0] ?? ''}`}
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </Tooltip>
                                                                )
                                                                : <span style={{ textAlign: 'center' }}>-</span>
                                                        }
                                                    </span>
                                                </TableCell>
                                                {!isLeadManageDeliveryRequested && (
                                                    <TableCell align={titles[14].align}>
                                                        <span>
                                                            <ActionsLead
                                                                lead_profile_access={lead_profile_access}
                                                                lead_id={lead._id}
                                                                lead_list={[]}
                                                                lead_pot={lead.lead_pot}
                                                                is_trade={lead.trade ? lead.trade.is_trade : false}
                                                                updateCheckBoxState={this.updateCheckBoxState}
                                                                division={lead.ref_lead_source}
                                                                assigned_person={lead.ref_assigned_to}
                                                                parent={this}
                                                                lead_status_id={lead.ref_lead_status ? lead.ref_lead_status._id : ''}
                                                            />
                                                        </span>
                                                    </TableCell>
                                                )
                                                }
                                                {
                                                    !isLeadManageDeliveryRequested && (this.checkPermissionForAllocate()
                                                        ? (
                                                            <TableCell align={titles[15].align}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedIds.has(lead._id)}
                                                                    onChange={this.updateCheckbox}
                                                                    data-id={lead._id}
                                                                    data-division={lodash.get(lead, 'ref_lead_source.abbr') || 'Unknown'}
                                                                />
                                                            </TableCell>
                                                        )
                                                        : (
                                                            <TableCell
                                                                align={titles[14].align}
                                                                style={{ textAlign: 'right' }}
                                                            >
                                                        &nbsp;
                                                            </TableCell>
                                                        ))
                                                }
                                            </TableRow>
                                        );
                                    })
                            }
                            {
                                !isLoading && lodash.isEmpty(leads) && <TableNoData colSpan={titles.length} />
                            }
                            {
                                !isLeadManageDeliveryRequested && (this.checkPermissionForAllocate() && leadList.length > 0
                                    && (
                                        <TableRow>
                                            <TableCell colSpan={titles.length - 2} />
                                            <TableCell
                                                style={{ padding: '0 5px', fontSize: '12px', textAlign: 'center' }}
                                            >
                                                <ActionsLead
                                                    lead_profile_access={lead_profile_access}
                                                    lead_id={null}
                                                    is_trade={false}
                                                    lead_list={leadList}
                                                    division={null}
                                                    updateCheckBoxState={this.updateCheckBoxState}
                                                    assigned_person={null}
                                                    parent={this}
                                                    setIsUpdating={this.setIsUpdating}
                                                />
                                            </TableCell>
                                            <TableCell>&nbsp;</TableCell>
                                        </TableRow>
                                    ))
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[100, 250, 500]}
                        component="div"
                        count={displayDataList}
                        rowsPerPage={pagination.rows_per_page}
                        page={pagination.page}
                        backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                        nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                        onPageChange={this.changePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                        labelDisplayedRows={() => {
                        }}
                    />
                </div>
                {this.state.isUpdating && (
                    <div className="bulk-actions-loader">
                        <Spin size="large" spinning tip="Updating Leads..." />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    leadsDivisions: state.Leads.Leads_manage.divisions,
    leadsStatus: state.Leads.Leads_manage.status,
    filters: state.Leads.Leads_manage.filters,
    pagination: state.Leads.Leads_manage.pagination,
    leads: state.Leads.Leads_manage.leads,
    loading: state.Leads.Leads_manage.loading,
    leadsCount: state.Leads.Leads_manage.leadsCount,
    users: state.Leads.Leads_manage.users,
    current_user: state.App.App_content.user,
    countyList: state.Leads.Leads_manage.countyList,
});


export default connect(mapStateToProps, {
    getLeadsRequest,
    getUsersList,
    setLeadManageKey,
    updateLeadManageKey,
    setLeadManagePagination,
})(withStyles(table_styles)(LeadsTable));

/*
Andy Roach
Luke Bennison
 */



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/components/LeadsTable.js